import React, { useEffect, useState } from 'react'
import axios from 'axios'
import _ from 'lodash'

import {
  IconButton,
  Tooltip,
  Typography,
  Chip,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  Select,
  MenuItem,
  Container,
  Button,
  Box,
} from '@mui/material'

import {
  DeleteOutlined as DeleteOutlinedIcon,
  AddOutlined as AddOutlinedIcon,
} from '@mui/icons-material/'

import { useAuthContext } from '../../../hooks/useAuthContext'
import { adminTeamsService } from '../../../services/admin/teams'

const ListDataDependencyManagement = () => {
  //state variables
  const [lists, setLists] = useState([])

  const [parentListId, setParentListId] = useState(-1)
  const [childListId, setChildListId] = useState(-1)

  const [parentListData, setParentListData] = useState([])
  const [childListData, setChildListData] = useState([])

  const [lddm, setLddm] = useState([])

  const [selectedChildListItem, setSelectedChildListItem] = useState({})
  const SOURCE_TYPE = {
    LIST: 'list',
    TEAM: 'team',
  }
  const [parentSourceType, setParentSourceType] = useState(SOURCE_TYPE.LIST) // default: list
  const [childSourceType, setRightSourceType] = useState(SOURCE_TYPE.LIST)

  const [teams, setTeams] = useState([])

  const { user } = useAuthContext()

  const NODE_BASE_URL = process.env.REACT_APP_NODE_BASE_URL

  let axiosOptions = {}
  if (user) {
    axiosOptions = {
      headers: { Authorization: `Bearer ${user.token}` },
    }
  }

  async function getListsFromServer() {
    const lists = (await axios.get(`${NODE_BASE_URL}/template/list/company`, axiosOptions)).data

    setLists(lists)
  }

  const fetchTeams = async () => {
    const teams = await adminTeamsService.getTeams(user)

    setTeams(teams)
  }

  async function getLddmFromServer(pListId) {
    const lddm = (
      await axios.get(
        `${NODE_BASE_URL}/template/list-data/lddm-by-parent-list-id/${pListId}`,
        axiosOptions
      )
    ).data

    setLddm(lddm)
  }

  async function getListDataFromServer(pListId, cListId) {
    if (pListId != -1) {
      const listData = (
        await axios.get(`${NODE_BASE_URL}/template/list-data/list/${pListId}`, axiosOptions)
      ).data

      setParentListData(listData)
    } else {
      setParentListData([])
    }

    if (cListId != -1) {
      const listData = (
        await axios.get(`${NODE_BASE_URL}/template/list-data/list/${cListId}`, axiosOptions)
      ).data

      setChildListData(listData)
    } else {
      setChildListData([])
    }
  }

  async function handleDeleteSingleLddm(pLdId, cLdId) {
    const oldLddm = [...lddm]

    try {
      setLddm(
        lddm.filter((lddmItem) => !(lddmItem.child_id == cLdId && lddmItem.parent_id == pLdId))
      )

      await axios.delete(
        `${NODE_BASE_URL}/admin/template/list/delete-single-lddm/${pLdId}/${cLdId}`,
        axiosOptions
      )
    } catch (err) {
      setLddm(oldLddm)
    }
  }

  async function handleAddSingleLddm(pLdId, cLdId, parentType, childType) {
    if (pLdId == -1 || cLdId == -1) {
      return
    }
    const oldLddm = [...lddm]

    try {
      setLddm([...lddm, { child_id: cLdId, parent_id: pLdId }])

      await axios.post(
        `${NODE_BASE_URL}/admin/template/list/add-single-lddm`,
        {
          parent_list_data_id: pLdId,
          child_list_data_id: cLdId,
          parent_type: parentType,
          child_type: childType,
        },
        axiosOptions
      )

      setSelectedChildListItem({})
    } catch (err) {
      setLddm(oldLddm)
    }
  }

  useEffect(() => {
    if (user) {
      getListsFromServer()
      fetchTeams()
    }
  }, [user])

  useEffect(() => {
    if (user) {
      getListDataFromServer(parentListId, childListId)

      // if (parentListId !== -1) {
      getLddmFromServer(parentListId)
      // }
    }
  }, [user, parentListId, childListId])

  let unmappedChildren = []

  if (parentListData?.length > 0 || childListData?.length > 0) {
    for (let childLD of childListData) {
      unmappedChildren.push(childLD)
    }
  }

  const childData =
    childSourceType === SOURCE_TYPE.TEAM
      ? teams.map((t) => ({ ...t, value: t.name })) // normalize to {value, id}
      : childListData

  const unmappedChildData =
    childSourceType === SOURCE_TYPE.TEAM
      ? teams.map((t) => ({ ...t, value: t.name }))
      : unmappedChildren

  return (
    <Container>
      <Typography variant="h5" color="textSecondary">
        Manage List's & Team's Parent-Child Relationship
      </Typography>
      <br />
      <Table stickyHeader aria-label="simple table" size="small">
        <TableHead>
          <TableRow>
            {/* LEFT ITEM SELECT */}
            <TableCell sx={{ padding: '10px' }} width={'50%'}>
              <Box display="flex" flexDirection="column" gap={1}>
                {/* LEFT SOURCE TYPE SELECT */}
                <Select
                  size="small"
                  fullWidth
                  value={parentSourceType}
                  onChange={(e) => {
                    setParentSourceType(e.target.value)
                    setParentListId(-1)
                  }}
                >
                  <MenuItem value={SOURCE_TYPE.LIST}>Lists</MenuItem>
                  <MenuItem value={SOURCE_TYPE.TEAM}>Teams</MenuItem>
                </Select>

                {parentSourceType === SOURCE_TYPE.LIST && (
                  <Select
                    size="small"
                    fullWidth
                    value={parentListId}
                    onChange={(e) => setParentListId(e.target.value)}
                  >
                    <MenuItem value={-1}>
                      {parentSourceType === SOURCE_TYPE.TEAM
                        ? '<Select Parent Team>'
                        : '<Select Parent List>'}
                    </MenuItem>
                    {(parentSourceType === SOURCE_TYPE.TEAM ? teams : lists)
                      .sort((a, b) => (a.name || a.list_name).localeCompare(b.name || b.list_name))
                      .map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name || item.list_name}
                        </MenuItem>
                      ))}
                  </Select>
                )}
              </Box>
            </TableCell>

            {/* RIGHT ITEM SELECT */}
            <TableCell sx={{ padding: '10px' }} width={'50%'}>
              <Box display="flex" flexDirection="column" gap={1}>
                {/* RIGHT SOURCE TYPE SELECT */}
                <Select
                  size="small"
                  fullWidth
                  value={childSourceType}
                  onChange={(e) => {
                    setRightSourceType(e.target.value)
                    setChildListId(-1)
                  }}
                >
                  <MenuItem value={SOURCE_TYPE.LIST}>Lists</MenuItem>
                  <MenuItem value={SOURCE_TYPE.TEAM}>Teams</MenuItem>
                </Select>
                {childSourceType === SOURCE_TYPE.LIST && (
                  <Select
                    size="small"
                    fullWidth
                    value={childListId}
                    onChange={(e) => setChildListId(e.target.value)}
                  >
                    <MenuItem value={-1}>
                      {childSourceType === SOURCE_TYPE.TEAM
                        ? '<Select Child Team>'
                        : '<Select Child List>'}
                    </MenuItem>
                    {(childSourceType === SOURCE_TYPE.TEAM ? teams : lists)
                      .sort((a, b) => (a.name || a.list_name).localeCompare(b.name || b.list_name))
                      .map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name || item.list_name}
                        </MenuItem>
                      ))}
                  </Select>
                )}
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {parentSourceType === SOURCE_TYPE.LIST &&
            parentListData
              .sort((a, b) => a.value.localeCompare(b.value))
              .map((pld, i) => (
                <TableRow key={i}>
                  <TableCell sx={{ padding: '10px' }}>
                    <Typography variant="caption" color="textSecondary">
                      {pld.value}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ padding: '10px' }}>
                    {childData
                      .filter((c) =>
                        lddm
                          .filter((lddmItem) => lddmItem.parent_id === pld.id)
                          .map((lddmItem) => lddmItem.child_id)
                          .includes(c.id)
                      )
                      .map((c) => {
                        const isRepeated =
                          lddm.filter((lddmItem) => lddmItem.child_id === c.id).length > 1

                        const tooltipContent = isRepeated
                          ? `This child item is linked to multiple parents:\n<ul style="list-style-type: disc; padding-left: 20px;">${lddm
                              .filter((lddmItem) => lddmItem.child_id === c.id)
                              .map((lddmItem) => {
                                const parent = parentListData.find(
                                  (parent) => parent.id === lddmItem.parent_id
                                )

                                return parent ? parent.value : null
                              })
                              .filter((parentValue) => parentValue !== null)
                              .sort((a, b) => a.localeCompare(b))
                              .map((parentValue) => `<li>${parentValue}</li>`)
                              .join('')}</ul>`
                          : ''

                        return (
                          <Tooltip
                            title={<span dangerouslySetInnerHTML={{ __html: tooltipContent }} />}
                            key={c.id}
                          >
                            <Chip
                              label={
                                c.value.length >= 80 ? c.value.substring(0, 80) + '...' : c.value
                              }
                              variant="outlined"
                              onClick={() => {}}
                              onDelete={() => {
                                handleDeleteSingleLddm(pld.id, c.id)
                              }}
                              deleteIcon={<DeleteOutlinedIcon sx={{ fontSize: '16px' }} />}
                              sx={{
                                backgroundColor: isRepeated ? 'lightgreen' : 'transparent',
                                marginRight: '8px',
                                padding: '5px 10px',
                              }}
                            />
                          </Tooltip>
                        )
                      })}
                    <br />
                    <br />
                    <Select
                      name={`select_${pld.id}`}
                      size="small"
                      variant="outlined"
                      color="primary"
                      fullWidth={true}
                      value={selectedChildListItem[`select_${pld.id}`] || -1}
                      onChange={(e) => {
                        setSelectedChildListItem({
                          ...selectedChildListItem,
                          [e.target.name]: e.target.value,
                        })
                      }}
                    >
                      <MenuItem value={-1}>{'<Select Child List Item>'}</MenuItem>
                      {unmappedChildData

                        .sort((a, b) => a.value.localeCompare(b.value))
                        .map((unmappedChild) => (
                          <MenuItem key={unmappedChild.id} value={unmappedChild.id}>
                            {unmappedChild.value}
                          </MenuItem>
                        ))}
                    </Select>
                    <br />
                    <br />
                    {selectedChildListItem[`select_${pld.id}`] !== undefined ? (
                      <Tooltip title={`Link child list item to parent list item: "${pld.value}"`}>
                        <Button
                          color="primary"
                          variant="contained"
                          size="small"
                          onClick={() =>
                            handleAddSingleLddm(
                              pld.id,
                              selectedChildListItem[`select_${pld.id}`],
                              parentSourceType,
                              childSourceType
                            )
                          }
                        >
                          Save
                        </Button>
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </TableCell>
                </TableRow>
              ))}

          {parentSourceType == SOURCE_TYPE.TEAM &&
            teams
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((pld, i) => (
                <TableRow key={i}>
                  <TableCell sx={{ padding: '10px' }}>
                    <Typography variant="caption" color="textSecondary">
                      {pld.name}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {childData
                      .filter((c) =>
                        lddm
                          .filter((lddmItem) => lddmItem.parent_id === pld.id)
                          .map((lddmItem) => lddmItem.child_id)
                          .includes(c.id)
                      )
                      .map((c) => {
                        const isRepeated =
                          lddm.filter((lddmItem) => lddmItem.child_id === c.id).length > 1

                        // const tooltipContent = isRepeated
                        //   ? `This child item is linked to multiple parents:\n<ul style="list-style-type: disc; padding-left: 20px;">${lddm
                        //       .filter((lddmItem) => lddmItem.child_id === c.id)
                        //       .map((lddmItem) => {
                        //         const parent = parentListData.find(
                        //           (parent) => parent.id === lddmItem.parent_id
                        //         )

                        //         return parent ? parent.value : null
                        //       })
                        //       .filter((parentValue) => parentValue !== null)
                        //       .sort((a, b) => a.localeCompare(b))
                        //       .map((parentValue) => `<li>${parentValue}</li>`)
                        //       .join('')}</ul>`
                        //   : ''

                        const tooltipContent = isRepeated
                          ? `This child item is linked to multiple parents:\n<ul style="list-style-type: disc; padding-left: 20px;">${lddm
                              .filter((lddmItem) => lddmItem.child_id === c.id)
                              .map((lddmItem) => {
                                let parent = null

                                if (lddmItem.parent_list_type === SOURCE_TYPE.LIST) {
                                  parent = parentListData.find((p) => p.id === lddmItem.parent_id)
                                } else if (lddmItem.parent_list_type === SOURCE_TYPE.TEAM) {
                                  parent = teams.find((t) => t.id === lddmItem.parent_id)
                                }

                                return parent ? parent.value || parent.name : null
                              })
                              .filter((parentValue) => parentValue !== null)
                              .sort((a, b) => a.localeCompare(b))
                              .map((parentValue) => `<li>${parentValue}</li>`)
                              .join('')}</ul>`
                          : ''

                        return (
                          <Tooltip
                            title={<span dangerouslySetInnerHTML={{ __html: tooltipContent }} />}
                            key={c.id}
                          >
                            <Chip
                              label={
                                c.value.length >= 80 ? c.value.substring(0, 80) + '...' : c.value
                              }
                              variant="outlined"
                              onClick={() => {}}
                              onDelete={() => {
                                handleDeleteSingleLddm(pld.id, c.id)
                              }}
                              deleteIcon={<DeleteOutlinedIcon sx={{ fontSize: '16px' }} />}
                              sx={{
                                backgroundColor: isRepeated ? 'lightgreen' : 'transparent',
                                marginRight: '8px',
                                padding: '5px 10px',
                              }}
                            />
                          </Tooltip>
                        )
                      })}
                    <br />
                    <br />
                    <Select
                      name={`select_${pld.id}`}
                      size="small"
                      variant="outlined"
                      color="primary"
                      fullWidth={true}
                      value={selectedChildListItem[`select_${pld.id}`] || -1}
                      onChange={(e) => {
                        setSelectedChildListItem({
                          ...selectedChildListItem,
                          [e.target.name]: e.target.value,
                        })
                      }}
                    >
                      <MenuItem value={-1}>{'<Select Child List Item>'}</MenuItem>
                      {unmappedChildData
                        .sort((a, b) => a.value.localeCompare(b.value))
                        .map((unmappedChild) => (
                          <MenuItem key={unmappedChild.id} value={unmappedChild.id}>
                            {unmappedChild.value}
                          </MenuItem>
                        ))}
                    </Select>
                    <br />
                    <br />
                    {selectedChildListItem[`select_${pld.id}`] !== undefined ? (
                      <Tooltip
                        title={`Link child list item to parent list item: "${
                          pld.value || pld.name
                        }"`}
                      >
                        <Button
                          color="primary"
                          variant="contained"
                          size="small"
                          onClick={() =>
                            handleAddSingleLddm(
                              pld.id,
                              selectedChildListItem[`select_${pld.id}`],
                              parentSourceType,
                              childSourceType
                            )
                          }
                        >
                          Save
                        </Button>
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </TableCell>
                </TableRow>
              ))}
          {parentListData && parentListData.length > 0 && (
            <TableRow>
              <TableCell sx={{ padding: '10px' }}>
                <Typography variant="caption" fontWeight="900" color="textSecondary">
                  unassigned
                </Typography>
              </TableCell>
              <TableCell sx={{ padding: '10px' }}>
                {unmappedChildren?.length > 0 &&
                  unmappedChildren
                    .sort((a, b) => a.value.localeCompare(b.value))
                    .map((unmappedChild) => (
                      <Typography
                        key={unmappedChild.id}
                        variant="caption"
                        fontWeight="900"
                        color="textSecondary"
                        display={'block'}
                        sx={{ mb: 2 }}
                      >
                        {unmappedChild.value}
                      </Typography>
                    ))}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Container>
  )
}

export default ListDataDependencyManagement
